import React from "react";
import { Icon } from "@iconify/react";
import Revolutionize from "./../../shared/revolutionize";
import { useTranslation } from "react-i18next";

const Revolution = () => {
  const { t } = useTranslation();

  return (
    <>
      <Revolutionize txt={t("home.revolution.transform")} />
      <div className="bg-[#FFFFFF] rounded-[38px] ">
        <div className=" flex flex-col md:flex-row justify-between pt-[175px] md-m:pt-[75px] max-md:mb-[68px] mb-[128px]  max-w-[80%] max-xxxl:max-w-[90%] w-full m-auto gap-[30px] max-sm:!gap-[15px]">
          {/* Left section with platform description */}
          <div className="w-[100%] md:w-[70%] max-w-[100%] max-md:pt-[50px]  relative pt-[112px]  pr-[37px] pl-[52px] md-m:pl-[20px] md-m:pr-[20px] flex flex-col justify-end max-h-[730px]">
            <img
              src="../../assets/images/home/revol-bg.png"
              alt="Kameleon AI Intelligent Chatbot Platform"
              className="absolute z-[1] h-full w-full right-[0] top-0"
            />
            <h4 className="heading-color  z-[1] font-sora">{t("home.revolution.title")}</h4>
            <div className="flex gap-[12px] max-md:mt-[30px] mt-[76px] w-full">
              <img
                src="../../assets/images/home/Dashboard.png"
                alt="Kameleon AI Intelligent Chatbot Platform"
                className=" max-h-[454px] z-[1] max-w-[70%] w-full"
              />
              <img
                src="../../assets/images/home/mobil-dashboard.png"
                alt="Kameleon AI Intelligent Chatbot Platform"
                className="max-h-[454px] z-[1] max-w-[30%] w-full"
              />
            </div>
          </div>

          {/* Right section with integration and deployment */}
          <div className="z-[1] w-[100%] md:w-[25%] max-w-[100%] relative max-h-[730px] max-sm:min-h-[530px] px-[42px]  md-m:px-[20px]  flex flex-col justify-between max-sm:items-center pt-[132px] pb-[86px] max-md:py-[20px] max-md:justify-center">
            <img
              src="../../assets/images/home/m-bg.png"
              alt="Kameleon AI Intelligent Chatbot Platform"
              className="absolute z-[-1] max-h-[730px] h-full w-full right-[0] top-[0] bottom-0"
            />
            <div className="flex flex-col gap-[16px] max-sm:items-center">
              <h5 className=" text-white max-w-[215px] font-sora max-sm:text-center">
                {t("home.revolution.RightCard.title")}
              </h5>
              <p className="mediumn font-medium leading-[30px] font-manrope text-white max-w-[300px] max-sm:text-center">
                {t("home.revolution.RightCard.desc")}
              </p>
            </div>

            <div className="flex flex-row justify-between max-md:mt-[20px] gap-[8px] max-sm:w-fit ">
              {/* Icon placeholders for integration options */}
              <Icon icon="logos:messenger" className="text-4xl text-blue-600" />
              <Icon icon="logos:skype" className="text-4xl text-blue-500" />
              <Icon icon="logos:telegram" className="text-4xl text-blue-400" />
              <Icon icon="skill-icons:discord" className="text-4xl text-purple-600" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Revolution;
